import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { globalTheme } from '../../../../../../../shared/theme/theme';
import { ReviewStatisticsBreakdownModel } from '../../../models/review-statistics-breakdown.model';
import { CustomTooltipProps } from '../../../shared/models/custom-tooltip-props.model';

export const CustomTooltipRatingsChart: FC<
  CustomTooltipProps<ReviewStatisticsBreakdownModel>
> = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const { rating, totalNrOfRatings } = payload[0].payload;
    return (
      <Box
        sx={{
          backgroundColor: globalTheme.palette.appWhite.main,
          padding: 1,
          borderRadius: 1,
          boxShadow: '0px 0px 5px rgba(0,0,0,0.1)',
        }}
      >
        <Typography sx={{ fontSize: '12px', margin: 0 }}>
          {rating} stars: {totalNrOfRatings} ratings
        </Typography>
      </Box>
    );
  }
  return null;
};
